import React from 'react';
import { concat, each, find, flatten, union, filter, difference, map } from 'lodash';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import * as classnames from 'classnames';
import SessionStatus from './SessionStatus';
import FileUpload from './FileUpload';
import FileDownload from './FileDownload';

import SessionTransformationStatus from './SessionTransformationStatus'
import SessionMessage from './SessionMessage';
import DataNodeStatus from './DataNodeStatus';
import SessionParticipant from './SessionParticipant';

const SessionTableRow = props => {
  const findDataTreeNodeForAbstractType = (equipmentFile, abstractType) => {
    if (!props.dataTree) {
      return null;
    }

    let dataTreeNode = null;

    const signalNodes = () =>
      filter(props.dataTree.data_tree_nodes, o => {
        return o.data_tree_node_signal !== null;
      });
    const occurenceNodes = () =>
      filter(props.dataTree.data_tree_nodes, o => {
        return o.data_tree_node_occurrence !== null;
      });

    if (abstractType.type === 'signal') {
      dataTreeNode = find(signalNodes(), dataTreeNode => {
        return (
          dataTreeNode.data_tree_node_signal.abstract_type_id === abstractType.id &&
          dataTreeNode.data_acquisition_instance.data_acquisition_id ===
            abstractType.data_acquisition_id
        );
      });
    } else if (abstractType.type === 'occurrence') {
      dataTreeNode = find(occurenceNodes(), dataTreeNode => {
        return (
          difference(
            dataTreeNode.data_tree_leafs.map(leaf => {
              return leaf.abstract_type_id;
            }),
            abstractType.ids
          ).length === 0
        );
      });
    }

    return dataTreeNode;
  };

  const sessionFileCells = props.fileTypes.map(equipmentFile => {

    const blueBoxIds = [10, 11, 25, 27, 30];
    const isBlueBox = blueBoxIds.includes(equipmentFile.id); // temporaire

    const nodeUpload = props.dataTree
      ? find(props.dataTree.data_tree_nodes, o => {
          return o.node_upload && o.node_upload.equipment_file_description_id === equipmentFile.id;
        })
      : null;
    return concat(
      <Table.Cell
        key={`session_${props.session.id}_upload_${equipmentFile.id}`}
        className="session__td--upload-file"
      >
        <FileUpload session={props.session} equipmentFile={equipmentFile} nodeUpload={nodeUpload} />
      </Table.Cell>,
      isBlueBox ?
        <Table.Cell
          key={`session_${props.session.id}_download_${equipmentFile.id}`}
          className="session__td--upload-file"
        >
          <FileDownload session={props.session} equipmentFile={equipmentFile} />
        </Table.Cell>
      : null,
      equipmentFile.abstract_types.map((abstractType, dn_id) => {
        const dataNode = findDataTreeNodeForAbstractType(equipmentFile, abstractType);
        return (
          <Table.Cell
            key={`file_${equipmentFile.id}_metric_${dn_id}`}
            className="session__td--metrics"
          >
            <DataNodeStatus
              session={props.session}
              abstractType={abstractType}
              dataNode={dataNode}
            />
          </Table.Cell>
        );
      })
    );
  });

  const participant =
    props.session.participations && props.session.participations.length > 0
      ? props.session.participations[0]
      : null;
  const isParticipationValid = participant && participant.status !== 'valid';

  const sessionRowClassnames = classnames({
    session__invalid: isParticipationValid
  });

  return (
    <Table.Row
      id={`session_${props.session.id}`}
      key={`session_${props.session.id}`}
      className={sessionRowClassnames}
    >
      <Table.Cell className="session__td--status">
        <SessionStatus
          sessionId={props.session.id}
          sessionStatus={participant ? participant.status : undefined}
        />
      </Table.Cell>
      <Table.Cell className="session__td--name">{props.session.name}</Table.Cell>
      <SessionParticipant participant={participant} />
      <Table.Cell className="session__td--condition">
        {participant ? participant.condition_id : null}
      </Table.Cell>
      {sessionFileCells}
      <Table.Cell className="session__td--transformation-status">
        <SessionTransformationStatus dataTree={props.dataTree} projectTransformations={props.dataTreeTransformations} />
      </Table.Cell>
      <Table.Cell className="session__td--messages">
        <SessionMessage dataTree={props.dataTree} messages={props.dataTreeMessages} />
      </Table.Cell>
    </Table.Row>
  );
};

SessionTableRow.propTypes = {
  session: PropTypes.object,
  fileTypes: PropTypes.array
};

// export default SessionTableRow;
export default connect((state, props) => {
  let dataTree;

  if (props.session.participations.length > 0) {
    const participation = props.session.participations[0];
    dataTree = find(state.projects.single.fileImport.dataTrees, {
      participation_id: participation.id
    });
  }

  let dataTreeMessages = [];
  let dataTreeTransformations = null;

  if (dataTree) {
    const node_operation_message_types = ['node_validation', 'node_sync','data_tree_node_transformation'];
    each(dataTree.data_tree_nodes, (dataTreeNode, key) => {
      each(node_operation_message_types, (operation, key) => {
        if (operation === 'data_tree_node_transformation') {
           if (dataTreeNode[operation] && dataTreeNode[operation].node_transformation_errors) {
            const errorMessages = map(dataTreeNode[operation].node_transformation_errors, message => {
              return { ...message, type: operation };
            });
            dataTreeMessages = flatten(union(dataTreeMessages, errorMessages));
          }
        } else if (dataTreeNode[operation] && dataTreeNode[operation][`${operation}_errors`]) {
          const errorMessages = map(dataTreeNode[operation][`${operation}_errors`], message => {
            return { ...message, type: operation };
          });
          dataTreeMessages = flatten(union(dataTreeMessages, errorMessages));
        }
      });
    });

    const transformationNodes = () =>
      filter(dataTree.data_tree_nodes, o => {
        return o.data_tree_node_transformation !== null;
      });
    dataTreeTransformations = transformationNodes();

  }

  return {
    dataTree,
    dataTreeMessages, 
    dataTreeTransformations,
  };
})(SessionTableRow);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/fileImport/SessionTableRow.js